import MusicHomePage from "./pages/MusicHome";
import MusicBio from "./pages/MusicBio";

import { BrowserRouter, Routes, Route } from "react-router-dom";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MusicHomePage />}></Route>
        <Route path="/bio" element={<MusicBio />}></Route>
      </Routes>
    </BrowserRouter>
  );
}
